<template>
  <div
      ref="trustboxRef"
      class="trustpilot-widget"
      :data-locale="locale"
      :data-template-id="templateId"
      :data-businessunit-id="businessUnitId"
      :data-style-height="styleHeight"
      :data-style-width="styleWidth"
      :data-theme="theme"
  >
    <a :href="reviewUrl" target="_blank" rel="noopener">
      Trustpilot
    </a>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

const templateId = '5419b732fbfb950b10de65e5';
const businessUnitId = '5b87f4053448bc00017f860f';
const reviewUrl = 'https://www.trustpilot.com/review/www.cosmosyachting.com';

const props = defineProps({
  locale: { type: String, default: 'en-US' },
  styleHeight: { type: String, default: '24px' },
  styleWidth: { type: String, default: '100%' },
  theme: { type: String, default: 'dark' },
});

const trustboxRef = ref<HTMLElement | null>(null);

onMounted(() => {
  const scriptUrl = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

  const initTrustpilot = () => {
    if (window.Trustpilot && trustboxRef.value) {
      window.Trustpilot.loadFromElement(trustboxRef.value, true);
    }
  };

  if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;
    script.onload = initTrustpilot;
    document.head.appendChild(script);
  } else {
    initTrustpilot();
  }
});
</script>

<style>
:deep(.tp-widget-wrapper) {
  text-align: left;
}
</style>